'use client'

import type { ReactNode } from 'react'

import { useDialogContext } from '@morpho-org/ui-v6/contexts'
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui'
import { Question } from '@repo/ui/icons'

import EarnDialogContentClient from '@/components/common/Dialog/EarnDialog/EarnDialogContentClient'
import { trackHowItWorksOpened } from '@/lib/analytics/client/trackers/how-it-works'

interface VaultSectionHeroProps {
  metricSlot?: ReactNode
}

export default function VaultSectionHero({ metricSlot }: VaultSectionHeroProps) {
  const { toggleDialog } = useDialogContext()

  const handleHelpClick = () => {
    trackHowItWorksOpened({ page: 'vaults', source: 'hero' })
    toggleDialog(<EarnDialogContentClient />, {
      closable: true,
      fullSize: true
    })
  }

  return (
    <div className="flex w-full items-center justify-between">
      <div className="gap-2xs flex flex-col">
        <div className="gap-xs flex items-center">
          <h1 className="text-title-sm">Vaults</h1>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="iconSm"
                aria-label="How it works"
                onClick={handleHelpClick}
              >
                <Question />
              </Button>
            </TooltipTrigger>
            <TooltipContent>How it works</TooltipContent>
          </Tooltip>
        </div>
        <p className="text-secondary-foreground text-sm">
          Earn by depositing into curated Morpho vaults.
        </p>
      </div>
      {metricSlot}
    </div>
  )
}
